import { profileActionTypes } from "../actions/index";


export const initialState = {
    isEmpty: false,
}

export const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case profileActionTypes.EMPTY_PROFILE:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}